/* libs/oyan-ui/src/lib/components/tab-nav-bar/tab-nav-bar.component.scss */
/*# sourceMappingURL=tab-nav-bar.component.css.map */
